// Loader.js
import React from 'react';

const Loader = () => (
    <div className="loader-backdrop">
        <div className="spinner"></div>
    </div>
);

export default Loader;
